export default __webpack_public_path__ + "static/Fall10-c26de884445a8929ec53574c28db66ae.mp3";